import { movies, news } from "@/mocks/movies";
import type { Movie, NewsItem } from "@/types/movie";

export const allMovies: Movie[] = movies as unknown as Movie[];
export const allNews: NewsItem[] = news as unknown as NewsItem[];

export function getMovieById(id: string): Movie | undefined {
  return allMovies.find((movie) => movie.id === id);
}

export function sortByKey(list: Movie[], key: string): Movie[] {
  const copy = [...list];
  if (key === "popularity") {
    return copy.sort((a, b) => b.popularity - a.popularity);
  }
  if (key === "rating") {
    return copy.sort((a, b) => b.rating - a.rating);
  }
  return copy.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}

export function matchYear(year: number, option: string): boolean {
  if (option === "全部") return true;
  if (option === "近五年") return year >= 2021;
  if (option === "更早") return year < 2022;
  return String(year) === option;
}